var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C23.1413 36 27.5925 34.1563 30.8744 30.8744C34.1563 27.5925 36 23.1413 36 18.5C36 13.8587 34.1563 9.40752 30.8744 6.12563C27.5925 2.84374 23.1413 1 18.5 1C13.8587 1 9.40752 2.84374 6.12563 6.12563C2.84374 9.40752 1 13.8587 1 18.5C1 23.1413 2.84374 27.5925 6.12563 30.8744C9.40752 34.1563 13.8587 36 18.5 36ZM26.365 21.775L19.3825 28.7575C19.1481 28.9918 18.8302 29.1235 18.4987 29.1235C18.1673 29.1235 17.8494 28.9918 17.615 28.7575L10.635 21.775C10.4607 21.6002 10.3421 21.3777 10.2941 21.1356C10.2461 20.8935 10.2709 20.6426 10.3653 20.4145C10.4596 20.1865 10.6194 19.9914 10.8245 19.854C11.0295 19.7167 11.2707 19.643 11.5175 19.6425H16V10.375C16 9.71196 16.2634 9.07607 16.7322 8.60723C17.2011 8.13839 17.837 7.875 18.5 7.875C19.163 7.875 19.7989 8.13839 20.2678 8.60723C20.7366 9.07607 21 9.71196 21 10.375V19.6425H25.4825C25.7293 19.643 25.9705 19.7167 26.1755 19.854C26.3806 19.9914 26.5404 20.1865 26.6347 20.4145C26.7291 20.6426 26.7539 20.8935 26.7059 21.1356C26.6579 21.3777 26.5393 21.6002 26.365 21.775Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ee47ff3f71d1d6a0313dd9f684607ee6.svg";
export { ForwardRef as ReactComponent };